import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
// import { News } from "./components/news";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import ProjectData from "./data/letbabytalkData.json";
// import NewsData from "./data/newsData.json";
import SmoothScroll from "smooth-scroll";
import { Project } from "./components/project";
// import { New } from "./components/new";
import { Tnc } from "./components/tnc";
import { Pp } from "./components/pp";
import { Da } from "./components/da";
import { Hackathon } from "./components/hackathon";
import { Hackathon2 } from "./components/hackathon2";
import { Survey } from "./components/survey";
import { Blog } from "./components/blog";
import { BlogPost } from "./components/blogPost";

import "./App.css";
import {
  BrowserRouter as Router,
  HashRouter,
  Route,
  Routes,
  useLocation,
  BrowserRouter,
} from "react-router-dom";

export const scroll = new SmoothScroll('a[href^="#"]:not([href^="#/"])', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [projectData, setProjectData] = useState({});
  // const [newsData, setNewsData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
    setProjectData(ProjectData);
    // setNewsData(NewsData);
  }, []);

  const Layout = ({ children }) => (
    <>
      <Navigation />
      {children}
    </>
  );

  return (
    <HashRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Header data={landingPageData.Header} />
              {/* <News data={landingPageData.News} /> */}
              <About data={landingPageData.About} />
              {/* <Features data={landingPageData.Features} /> */}
              <Services data={landingPageData.Services} />
              {/* <Blog data={landingPageData.Blog} /> */}
              {/* <Testimonials data={landingPageData.Testimonials} /> */}
              <Team data={landingPageData.Team} />
              <Gallery data={landingPageData.Gallery} />
              <Contact data={landingPageData.Contact} />
            </Layout>
          }
        />

        <Route
          path="/project/:id"
          element={
            // <Layout>
            <Project data={projectData.letbabytalk} from="homepage" />
            // </Layout>
          }
        />
        {/* <Route
          path="/news/:id"
          element={
            <Layout>
              <New data={newsData.letbabytalk} />
            </Layout>
          }
        /> */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/termsnconditions" element={<Tnc />} />
        <Route path="/privacypolicy" element={<Pp />} />
        <Route path="/deactivateaccount" element={<Da />} />
        {/* <Route path="/hackathon" element={<Hackathon />} /> */}
        <Route path="/hackathon2" element={<Hackathon />} />
        <Route path="/survey" element={<Survey />}></Route>
      </Routes>
    </HashRouter>
  );
};

export default App;

// https://github.com/issaafalkattan/React-Landing-Page-Template/tree/master
// https://medium.com/@rizkiprass/step-by-step-guide-deploying-a-react-app-on-aws-ec2-b2965af05aa4

// sudo service apache2 stop
